import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate } from "../../../Utils/DateAndTime";


function ProjectForm({mode}) {


  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectData = async () => {

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/projects/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_category_id: data.organization_project_category_id || "",
          organization_project_subcategory_id: data.organization_project_subcategory_id || "",
          organization_project_type_id: data.organization_project_type_id || "",
          organization_client_id: data.organization_client_id || "",
          project_name: data.project_name || "",
          project_source: data.project_source || "",
          project_short_name: data.project_short_name || "",
          description: data.description || "",
          is_billable: data.is_billable || false,
          billing_model: data.billing_model || "",
          billing_frequency: data.billing_frequency || "",
          estimated_hours_period: data.estimated_hours_period || "",
          estimated_hours: data.estimated_hours || "",
          start_date: formatDate(data.start_date) || "",
          expected_end_date: formatDate(data.expected_end_date) || "",
          priority: data.priority || "",
          project_status: data.project_status || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchProjectData();
    }
  }, [mode, id]);


  // console.log("org here is : ", org);


  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_category_id: "",
    organization_project_subcategory_id: "",
    organization_project_type_id: "",
    organization_client_id: "",
    project_name: "",
    project_source: "",
    project_short_name: "",
    description: "",
    is_billable: false,
    billing_model: "",
    billing_frequency: "",
    estimated_hours_period: "",
    estimated_hours: "",
    start_date: "",
    expected_end_date: "",
    priority: "",
    project_status: ""
  });



  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_project_category_id) errors.organization_project_category_id = "Project Category is required";
    if (!formData.project_name) errors.project_name = "Project name is required";
    if (!formData.project_source) errors.project_source = "Project source is required";
    if (!formData.project_status) errors.project_status = "Project Status is required";
    if (!formData.estimated_hours_period) errors.estimated_hours_period = "Project Allocated Hours period is required";
    if (!formData.estimated_hours) errors.estimated_hours = "Project Allocated Hours is required";
    if (formData.project_name.length > 150) errors.project_name = "Max 150 characters allowed";
    if (formData.description.length > 255) errors.description = "Max 255 characters allowed";
    if (formData.project_short_name && formData.project_short_name.length > 20)
      errors.project_short_name = "Max 20 characters allowed";

    if (formData.project_source == "Client" && !formData.organization_client_id) errors.organization_client_id = "Project Client is required if source is Client";

    if (formData.is_billable == true) {
      if (!formData.billing_model) errors.billing_model = "Billable Model is required";
      if (!formData.billing_frequency) errors.billing_frequency = "Billable Model is required";
    }

    if (formData.priority && !["Low", "Medium", "High", "Critical"].includes(formData.priority))
      errors.priority = "Invalid priority";

    if (
      formData.project_status &&
      !["Planned", "In Progress", "On Hold", "Completed", "Cancelled"].includes(formData.project_status)
    )
      errors.project_status = "Invalid status";

    if (
      formData.estimated_hours_period &&
      !["Per Project", "Per Year", "Per Month", "Per Week"].includes(formData.estimated_hours_period)
    )
      errors.estimated_hours_period = "Invalid Period";

    const startDate = formData.start_date ? new Date(formData.start_date).setHours(0, 0, 0, 0) : null;
    const expectedEndDate = formData.expected_end_date ? new Date(formData.expected_end_date).setHours(0, 0, 0, 0) : null;
    // const actualEndDate = formData.actual_end_date ? new Date(formData.actual_end_date).setHours(0, 0, 0, 0) : null;

    if (expectedEndDate && startDate && expectedEndDate < startDate) {
      errors.expected_end_date = "Expected end date must be after or equal to start date";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [selectOptions, setSelectOptions] = useState({
    Clients: [],
    Types: [],
    Categories: [],
    Employees: [],
    SubCategories: []
  })

  const fetchClients = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/clients`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response clients is : ", response);

      setSelectOptions((prev) => ({ ...prev, Clients: response.data.data }));
    } catch (e) {
      console.error("Failed to load clients");
    }
  };

  const fetchProjectTypes = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-types`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Types is : ", response);

      setSelectOptions((prev) => ({ ...prev, Types: response.data.data }));
    } catch (e) {
      console.error("Failed to load Types");
    }
  };

  const fetchProjectCategories = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Categories is : ", response);

      setSelectOptions((prev) => ({ ...prev, Categories: response.data.data }));
    } catch (e) {
      console.error("Failed to load Categories");
    }
  };

  const fetchEmployeesOfOrg = async () => {
    try {
      // const response = await axios.get(`${MAIN_URL}/api/organizations/employees?type=Intern`, {
      const response = await axios.get(`${MAIN_URL}/api/organizations/${org.organization_id}/persons-data-all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },

      });


      console.log("response Employees is : ", response);

      const sortedEmps = [...response.data.persons].sort((a, b) =>
        (`${a.first_name} ${a.last_name} - ${a.emp.organization_person?.person_code}` || "").localeCompare(`${b.first_name} ${b.last_name} - ${b.organization_person?.person_code}` || "")
      );
      setSelectOptions((prev) => ({ ...prev, Employees: sortedEmps }));
    } catch (e) {
      console.error("Failed to load Employees");
    }
  };

  const fetchProjectSubCategories = async (category_id) => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-sub-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          category_id
        },
      });

      console.log("response SubCategories is : ", response);

      setSelectOptions((prev) => ({ ...prev, SubCategories: response.data.data }));
    } catch (e) {
      console.error("Failed to load SubCategories");
    }
  };

  useEffect(() => {
    if (formData?.organization_project_category_id) {
      fetchProjectSubCategories(formData?.organization_project_category_id);
    }
  }, [formData?.organization_project_category_id]);

  useEffect(() => {

    if (org?.organization_id != undefined && org?.organization_id != null) {
      fetchClients();
      fetchProjectTypes();
      fetchProjectCategories();
      fetchEmployeesOfOrg();

    }
  }, [org]);

  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");

      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/projects/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/projects`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project added");
      }

      navigate("/project");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };

  // Handle input changes
  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));

  };


  useEffect(() => {
    if (formData.project_source == "Internal") {
      handleChange({ target: { name: "organization_client_id", value: null } })
    }
  }, [formData.project_source])





  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={" Project"}
        addMessage={" Project"}
        homeLink={"/project"}
        homeText={"Project"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

             

<Autocomplete
 disabled={mode === "view" ? true : false}
  fullWidth
  options={selectOptions?.Categories || []}
  getOptionLabel={(option) => option.project_category_name || ""}
  value={
    selectOptions?.Categories?.find(
      (cat) =>
        cat.organization_project_category_id ===
        formData.organization_project_category_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_category_id:
        newValue?.organization_project_category_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_category_id ===
    value.organization_project_category_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Category *"
      error={!!formErrors.organization_project_category_id}
      helperText={formErrors.organization_project_category_id}
    />
  )}
/>


             

<Autocomplete
  fullWidth
  disabled={selectOptions.SubCategories.length === 0|| mode === "view" ? true : false}
  options={selectOptions?.SubCategories || []}
  getOptionLabel={(option) => option.project_subcategory_name || ""}
  value={
    selectOptions?.SubCategories?.find(
      (cat) =>
        cat.organization_project_subcategory_id ===
        formData.organization_project_subcategory_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_subcategory_id:
        newValue?.organization_project_subcategory_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_subcategory_id ===
    value.organization_project_subcategory_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Sub Category"
      error={!!formErrors.organization_project_subcategory_id}
      helperText={
        selectOptions.SubCategories.length === 0
          ? "No SubCategories Available For This Category"
          : formErrors.organization_project_subcategory_id
      }
    />
  )}
/>


              
<Autocomplete
 disabled={mode === "view" ? true : false}
  fullWidth
  options={selectOptions?.Types || []}
  getOptionLabel={(option) => option.project_type_name || ""}
  value={
    selectOptions?.Types?.find(
      (type) =>
        type.organization_project_type_id === formData.organization_project_type_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_type_id: newValue?.organization_project_type_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_type_id === value.organization_project_type_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Type"
      error={!!formErrors.organization_project_type_id}
      helperText={formErrors.organization_project_type_id}
    />
  )}
/>


              

<Autocomplete
 disabled={mode === "view" ? true : false}
  fullWidth
  options={["Client", "Internal"]}
  value={formData.project_source || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      project_source: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Source *"
      error={!!formErrors.project_source}
      helperText={formErrors.project_source}
    />
  )}
/>




<Autocomplete

  fullWidth
  disabled={formData.project_source !== "Client" || !formData.project_source|| mode === "view" ? true : false}
  options={selectOptions?.Clients || []}
  getOptionLabel={(option) => option.client_name || ""}
  value={
    selectOptions?.Clients?.find(
      (client) =>
        client.organization_client_id === formData.organization_client_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_client_id: newValue?.organization_client_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_client_id === value.organization_client_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Client *"
      error={!!formErrors.organization_client_id}
      helperText={formErrors.organization_client_id}
    />
  )}
/>




                <TextField
                 disabled={mode === "view" ? true : false}
                  fullWidth
                  label="Project Name *"
                  name="project_name"
                  value={formData.project_name}
                  onChange={handleChange}
                  error={!!formErrors.project_name}
                  helperText={formErrors.project_name}
                />

                <TextField
                 disabled={mode === "view" ? true : false}
                  fullWidth
                  label="Project Short Name "
                  name="project_short_name"
                  value={formData.project_short_name}
                  onChange={handleChange}
                  error={!!formErrors.project_short_name}
                  helperText={formErrors.project_short_name}
                />

                <TextField
                 disabled={mode === "view" ? true : false}
                  fullWidth
                  multiline
                  minRows={3}
                  label="Project Description "
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />


                <FormGroup row sx={{ mt: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                      disabled={mode === "view" ? true : false}
                        name="is_billable"
                        checked={formData.is_billable}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_billable: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Is Billable *"
                  />
                </FormGroup>

            

<Autocomplete
  fullWidth
  disabled={!formData.is_billable||mode === "view" ? true : false}
  options={["Fixed Price", "Dedicated Resources", "Time & Material", "Usage based Pricing"]}
  value={formData.billing_model || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      billing_model: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Billing Model *"
      error={!!formErrors.billing_model}
      helperText={formErrors.billing_model}
    />
  )}
/>


        

<Autocomplete
  

  fullWidth
  disabled={!formData.is_billable||mode === "view" ? true : false}
  options={["One Time", "Annually", "Quarterly", "Monthly", "Weekly"]}
  value={formData.billing_frequency || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      billing_frequency: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Billing Frequency *"
      error={!!formErrors.billing_frequency}
      helperText={formErrors.billing_frequency}
    />
  )}
/>




           
<Autocomplete
  disabled={mode === "view" ? true : false}

  fullWidth
  options={["Per Project", "Per Year", "Per Month", "Per Week"]}
  value={formData.estimated_hours_period || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      estimated_hours_period: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Allocated Hours Period *"
      error={!!formErrors.estimated_hours_period}
      helperText={formErrors.estimated_hours_period}
    />
  )}
/>


                <TextField
  disabled={mode === "view" ? true : false}

                  fullWidth
                  label="Allocated Hours *"
                  name="estimated_hours"
                  type="number"
                  value={formData.estimated_hours}
                  onChange={handleChange}
                  error={!!formErrors.estimated_hours}
                  helperText={formErrors.estimated_hours}
                />


                <TextField
  disabled={mode === "view" ? true : false}

                  fullWidth
                  label="Project Start Date "
                  name="start_date"
                  type="date"

                  InputLabelProps={{ shrink: true }}
                  value={formData.start_date}
                  onChange={handleChange}
                  error={!!formErrors.start_date}
                  helperText={formErrors.start_date}
                />

                <TextField
  disabled={mode === "view" ? true : false}

                  fullWidth
                  label="Project Expected End Date "
                  name="expected_end_date"
                  type="date"

                  InputLabelProps={{ shrink: true }}
                  value={formData.expected_end_date}
                  onChange={handleChange}
                  error={!!formErrors.expected_end_date}
                  helperText={formErrors.expected_end_date}
                />




<Autocomplete
  fullWidth
  disabled={mode === "view" ? true : false}
  options={["Low", "Medium", "High", "Critical"]}
  value={formData.priority || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      priority: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Priority"
      error={!!formErrors.priority}
      helperText={formErrors.priority}
    />
  )}
/>


             

<Autocomplete
  disabled={mode === "view" ? true : false}

  fullWidth
  options={["Planned", "In Progress", "On Hold", "Completed", "Cancelled"]}
  value={formData.project_status || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      project_status: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Status *"
      error={!!formErrors.project_status}
      helperText={formErrors.project_status}
    />
  )}
/>


              </Grid>
             
              {mode !== "view" && (
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                  disabled={loading || btnLoading}
                  sx={{
                    borderRadius: 2,
                    minWidth: 120,
                    textTransform: "capitalize",
                    fontWeight: 500,
                    mt: 2
                  }}
                >
                  {loading || btnLoading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : mode === "edit" ? (
                    "Update"
                  ) : (
                    "Submit"
                  )}
                </Button>
              )}

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectForm
